export default __webpack_public_path__ + "static/media/GmOnline.a396e1a1.svg";